import { EpaperPublicationType, Issue } from '@news-mono/web-common'
import React from 'react'
import { useSection } from '../../../../__helpers'
import { useProduct } from '../../../../__product'
import { EpaperCollection } from '../EpaperCollection'
import { StyledLatestEditionContainer } from '../EpaperCollection.styled'
import { StyledReadersAlsoLoveHeading } from './ReadersAlsoLove.styled'

export interface ReadersAlsoLoveProps {
    allEditions: Issue[]
    border?: boolean
}

export const ReadersAlsoLove: React.FC<ReadersAlsoLoveProps> = (props) => {
    const section = useSection()
    const product = useProduct()

    return (
        <div>
            <StyledReadersAlsoLoveHeading border={props.border}>
                Readers also love
            </StyledReadersAlsoLoveHeading>
            <StyledLatestEditionContainer>
                <EpaperCollection
                    openEReaderOnCardClick={false}
                    showMastheadName={true}
                    issues={props.allEditions}
                    onCardClick={(link) => {
                        window.open(link, '_blank')
                    }}
                    ReadersAlsoLove={true}
                    sectionToExclude={
                        product === 'thewest'
                            ? (section as EpaperPublicationType)
                            : section === 'default'
                            ? undefined
                            : 'perthnow'
                    }
                />
            </StyledLatestEditionContainer>
        </div>
    )
}
